<template>
  <div class="chart-wrap">
    <!-- 图表 -->
    <div class="chart" ref="chart" :style="{height:chartHeight}"></div>
    <!-- 自定义图例 -->
    <chart-legend-sort
      v-if="isLegendSort"
      :legendLeft="legendLeft"
      :legendRight="legendRight"
      :chartData="chartData"
      :legendCols="legendCols"
      :showBtn="showBtn"
      legendAction="highlight"
      :color="color"
      :reverse="reverse" />
    <chart-legend
      v-else
      :chartData="chartData"
      :legendCols="legendCols"
      :showBtn="showBtn"
      legendAction="highlight"
      :color="color"
      :reverse="reverse" />
  </div>
</template>

<script>
import * as echarts from 'echarts'
import resize from '@/common/mixins/resize'
import ChartLegend from '@/components/analyse/chart-legend'
import ChartLegendSort from '@/components/analyse/chart-legend-sort'
import { colors } from '@/common/config'

export default {
  mixins: [resize],
  components: {
    ChartLegend,
    ChartLegendSort
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    legendCols: {
      type: [Number, String],
      default: 2
    },
    showBtn: {
      type: Boolean,
      default: false
    },
    chartData: {
      type: Array,
      default() {
        return []
      }
    },
    color: {
      type: Array,
      default() {
        return []
      }
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    // 是否反转数据
    reverse: {
      type: Boolean,
      default: false
    },
    // 是否对legend进行排序
    isLegendSort: {
      type: Boolean,
      default: false
    },
    legendLeft: {
      type: Array,
      default() {
        return []
      }
    },
    legendRight: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      chart: null,
      option: {},
      timer: null
    }
  },
  watch: {
    chartData() {
      this.setData()
      // 隐藏loading
      this.chart.hideLoading()
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chart)
      // 显示loading
      if(!this.chartData.length) {
        this.chart.showLoading({
          text: '',
          color: '#4292F5'
        })
      }
      this.setData()
    },
    setData() {
      const total = this.chartData.reduce((total, current) => {
        return total + Number(current.value || 0)
      }, 0)
      // 是否需要反转数据，目前仅在男女比例上需要
      const data = [...this.chartData]
      const newData = data.reverse()
      this.option = {
        color: this.color.length ? this.color : colors,
        title: {
          text: this.title,
          left: 'center',
          top: '45%',
          textStyle: {
            fontSize: 16
          }
        },
        legend: { show: false }, // 必须配置，否则无法触发legend事件
        tooltip: {
          confine: true,
          triggerOn: 'click',
          backgroundColor: '#fff',
          textStyle: { color: '#222' },
          extraCssText: 'box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);',
          formatter(params) {
            return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:6px;height:6px;background-color:${params.color};"></span>${params.name}：${(params.value / total * 100).toPrecision(4)}%`
          }
        },
        series: [
          {
            name: this.title,
            type: 'pie',
            radius: ['55%', '80%'],
            minAngle: 10,
            selectedOffset: 0,
            label: {
              show: this.showLabel,
              // position: 'inner',
              formatter(params) {
                return `${params.percent}%`
              }
            },
            labelLine: {
              show: this.showLabel,
              length: 7,
              // length2: 7,
              smooth: false
            },
            data: this.reverse ? newData : this.chartData
          }
        ]
      }
      this.chart.setOption(this.option)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
